import { Container, Variant } from "@carfax/web-ui/elements/Container";
import { CategoryCard } from "@carfax/web-ui/components/CategoryCard";
import { SectionHeadline } from "@carfax/web-ui/elements/SectionHeadline";
import { useRoutes } from "domain/Routing/hooks/useRoutes";
import { Accordion } from "components/Accessories/Accordion/Accordion";
import { styles } from "./PrivacyHubContent.style";
import { Icons } from "@carfax/web-ui/elements/Icon";
import { linkUtil } from "utils/i18n/link-util";
import { languageConfig } from "i18n/language-config";
import { useTranslations, useLocale } from "next-intl";
import Link from "i18n/components/Link";

export const PrivacyHubContent: React.FC = () => {
  const t = useTranslations("page-privacy-hub");
  const locale = useLocale();
  const routes = useRoutes();

  const language = languageConfig.mapLocaleToLanguageShort(locale);

  const privacyCards = [
    {
      title: t("PrivacyNoticeForWebsiteUsers.title"),
      excerpt: t("PrivacyNoticeForWebsiteUsers.excerpt"),
      icon: Icons.websiteUsers,
      href: linkUtil.i18nLinkWithLanguage(routes.privacy, language),
      linkSeeAllArticlesLabel: t("readMore"),
    },
    {
      title: t("PrivacyNoticeForBuyers.title"),
      excerpt: t("PrivacyNoticeForBuyers.excerpt"),
      icon: Icons.buyers,
      href: linkUtil.i18nLinkWithLanguage(routes.privacyPolicyCheckout, language),
      linkSeeAllArticlesLabel: t("readMore"),
    },
    {
      title: t("PrivacyNoticeForUsedCarOwners.title"),
      excerpt: t("PrivacyNoticeForUsedCarOwners.excerpt"),
      icon: Icons.carOwners,
      href: linkUtil.i18nLinkWithLanguage(routes.privacyNoticeForCarOwners, language),
      linkSeeAllArticlesLabel: t("readMore"),
    },
    {
      title: t("PrivacyNoticeForWhistleBlowers.title"),
      excerpt: t("PrivacyNoticeForWhistleBlowers.excerpt"),
      icon: Icons.whistleBlowers,
      href: linkUtil.i18nLinkWithLanguage(routes.privacyNoticeForWhistleBlowers, language),
      linkSeeAllArticlesLabel: t("readMore"),
    },
    {
      title: t("PrivacyNoticeForBusinessCustomers.title"),
      excerpt: t("PrivacyNoticeForBusinessCustomers.excerpt"),
      icon: Icons.businessCustomers,
      href: linkUtil.i18nLinkWithLanguage(routes.privacyNoticeForBusinessCustomers, language),
      linkSeeAllArticlesLabel: t("readMore"),
    },
    {
      title: t("PrivacyNoticeForLinkedinFanPage.title"),
      excerpt: t("PrivacyNoticeForLinkedinFanPage.excerpt"),
      icon: Icons.linkedinFanPage,
      href: linkUtil.i18nLinkWithLanguage(routes.privacyNoticeForLinkedinFanPage, language),
      linkSeeAllArticlesLabel: t("readMore"),
    },
  ];

  const privacyCardsMobile = privacyCards.map((item) => ({
    title: item.title,
    body: item.excerpt,
    icon: item.icon,
    iconTitle: item.title,
    linkUrl: item.href,
    linkText: item.linkSeeAllArticlesLabel,
  }));

  return (
    <>
      <Container paddingTop={Variant.Top.Standard}>
        <SectionHeadline headline={t("headline")} isMainHeadline={true} />
        <div className={styles.privacyCards()}>
          {privacyCards.map((privacyCard) => {
            const { href, ...rest } = privacyCard;

            return (
              <div className={styles.privacyCardWrapper()} key={`privacyCard-${privacyCard.title}`}>
                <Link href={href} className={styles.privacyCategoryLink()}>
                  <CategoryCard {...rest} />
                </Link>
              </div>
            );
          })}
        </div>
      </Container>
      <div className={styles.privacyCardsMobile()}>
        <Accordion items={privacyCardsMobile} iconFromCMS={true} />
      </div>
    </>
  );
};
